import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useKeycloak } from '@react-keycloak/web';

import keycloak from 'keycloak';
import getTranslate from '../../customHooks/getTranslate';
import styles from './styles.module.scss';

const AccountActions: React.FC = () => {
  // eslint-disable-next-line no-shadow
  const { keycloak } = useKeycloak();

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" />

      <Dropdown.Menu variant="dark" className="bg-secondary">
        <Dropdown.Item
          eventKey="1"
          onClick={() => keycloak.logout({ redirectUri: window.location.origin })}
        >
          {getTranslate('exit')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const CustomToggle = React.forwardRef<
  HTMLButtonElement,
  { onClick:(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void }
    >(({ onClick }, ref) => (
      <button
        ref={ref}
        type="button"
        className={styles.toggler}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {getTranslate('hello')}
        ,
        {' '}
        {keycloak.tokenParsed?.given_name}
      </button>
    ));

export default AccountActions;
